<template>
  <div class="select-option">
    <InputCheckbox
      v-if="checkbox"
      :value="value"
      :inputValue="inputValue"
      :label="label"
      :checked="isChecked"
      :class="{ disabled: disabled }"
      @change="handleEvent($event)"
    >
      <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="props">
        <slot v-bind="props" :name="slot" />
      </template>
    </InputCheckbox>

    <button v-else type="button" @click="handleEvent(inputValue)">
      <slot name="inputRadioLabel" :inputValue="inputValue" :label="label">{{
        label
      }}</slot>
    </button>
  </div>
</template>

<script>
/**
 * Componente que representa uma opção de uma lista de um select
 */
import isEqual from 'lodash.isequal'
import InputCheckbox from './InputCheckbox'

export default {
  name: 'SelectOption',
  components: {
    InputCheckbox
  },
  props: {
    inputValue: [String, Number, Object],
    value: [Array, Number, String, Object],
    /**
     * Texto do input
     */
    label: {
      type: String,
      required: true
    },
    /**
     * Se deve apresentar checkbox
     */
    checkbox: {
      type: Boolean,
      default: false
    },
    /**
     * Se está desabilitado
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isChecked() {
      return this.value.findIndex((item) => isEqual(item, this.inputValue)) > -1
    }
  },
  methods: {
    handleEvent(value) {
      this.$emit('input', value)

      if (this.checkbox) {
        this.$emit('change', value)
      } else {
        this.$emit('click', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-option {
  cursor: pointer;

  button {
    width: 100%;
    border: none;
    background: none;
    text-align: left;

    display: block;
    font-size: font-size('size-medium');
    font-weight: font-weight('weight-normal');
  }
}
</style>
